import React, { useState } from 'react';
import styles from "./CopyBtn.module.scss";
import { CopyIcon, TickIcon2 } from '../../../assets/icons/svgicons';

const CopyBtn = ({ text, className, }) => {
    const [copied, setCopied] = useState(true);
    const handleClick = () => {
        setCopied(false);
        navigator.clipboard.writeText(text)
        setTimeout(() => {
            setCopied(true)
        }, 1000);
    }
    return (
        <>
            <button
                className={`${styles.copy_btn} ${className || ""}`}
                onClick={handleClick}
            >
                {
                    copied ?
                        <CopyIcon />
                        :
                        <TickIcon2 />
                }
            </button>
        </>
    )
}

export default CopyBtn
